export default __webpack_public_path__ + "static/media/logo_caption_full@2x.910b0d16.png";